import { NgModule } from '@angular/core';
import { NewsComponent } from '~shared/svgs/news/news.component';

@NgModule({
  declarations: [NewsComponent],
  exports: [NewsComponent],
})
export class NewsModule {}